/*
//-------------------------------------------------------
//   Copyright (c) 2024 Templa Computer Systems Ltd
//
//   App:        EmployeePortal.UI
//   Object:     DataFormImage
//   DataForms:    DataForm field for DataForm
//
// Log      Date   By  Scan Description
// -----  -------- --- ---- ------------------------------
// WI3713 31/01/24 JC		New
//-------------------------------------------------------
*/
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Col, Row } from 'react-bootstrap';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import EPSignaturePad from './EPSignaturePad'; 
import { dataFormDataTypes } from '../constants/DataFormDataTypes';

class DataFormImage extends Component {
	constructor(props) {
		super(props);

		this.handleRemoveButtonOnClick = this.handleRemoveButtonOnClick.bind(this);
		this.handleImageFileAdded = this.handleImageFileAdded.bind(this);
		this.handleSignatureImageFileRemoved = this.handleSignatureImageFileRemoved.bind(this);
		this.handleSignatureImageFileAdded = this.handleSignatureImageFileAdded.bind(this);
	}

	handleRemoveButtonOnClick = event => {
		event.preventDefault();

		//pass to parent component's changed event
		this.props.changed({ lineNumber: this.props.item.lineNumber, isChanged: true, answer: '', dataType: this.props.item.dataType });
	}

	// handle image file added
	handleImageFileAdded = (event) => {

		if (event.target.files.length !== 0) {

			//get the file
			var fileToRead = event.target.files[0];

			//reinforce the file extension
			if (fileToRead != null && fileToRead.name != null &&
				(fileToRead.name.endsWith(".gif") || fileToRead.name.endsWith(".jpg") || fileToRead.name.endsWith(".png"))) {

				//get a ref to the props to get round ref image in reader onloadend
				var localProps = this.props;

				// ... read the image 
				var reader = new FileReader();
				reader.onloadend = function () {

					//pass to parent component's changed event
					localProps.changed({ lineNumber: localProps.item.lineNumber, isChanged: true, answer: reader.result, dataType: localProps.item.dataType });
				};

				//read as data URL
				reader.readAsDataURL(fileToRead);
			}
		}
	}

	// handle signature image file removed
	handleSignatureImageFileRemoved = () => {

		//pass to parent component's changed event
		this.props.changed({ lineNumber: this.props.item.lineNumber, isChanged: true, answer: '', dataType: this.props.item.dataType });
	}

	// handle signature image file added
	handleSignatureImageFileAdded = (newValue) => {

		//pass to parent component's changed event
		this.props.changed({ lineNumber: this.props.item.lineNumber, isChanged: true, answer: newValue, dataType: this.props.item.dataType });
	}

	render() {
		const { item, editing } = this.props;

		//always treat a signature box as allowing image upload
		const editingAndAllowsImageUpload = editing && (item.allowsImageUpload || item.dataType === dataFormDataTypes.signature_box );

		//get document content details as different if user entered
		let hasDocumentContent = item.hasDocumentContent;
		let documentSource = `data:image/${item.documentExtension};base64,${item.documentContent}`;
		if (item.hasNewAnswer && editingAndAllowsImageUpload)
		{
			documentSource = item.answer;
			hasDocumentContent = item.answer.length > 0;
		}

		//show image or signature pad? - it's an image or a signature box when either we're not editing, or there's document content
		const showImage = item.dataType === dataFormDataTypes.image || (item.dataType === dataFormDataTypes.signature_box && (!editing || hasDocumentContent));

		return (

			//show image?
			showImage ?

				/* ---------------------------------------------
				 * not editing, or item doesn't allow image upload 
				--------------------------------------------- */
				!editingAndAllowsImageUpload ?

					/*photo column, full width if we have an image*/
					<Row key={`itemdiv~${item.lineNumber}`}>
						< Col sm={12} className="text-col">
							{hasDocumentContent ?
								<img className="image-preview" src={documentSource} alt={item.lineText} />
								: []}
						</Col>
					</Row>
				:
				/* ---------------------------------------------
				* editing and allows image upload
				--------------------------------------------- */

					/* if the item has document content */
					hasDocumentContent ?
						/*photo column*/
						<Row key={`itemdiv~${item.lineNumber}`}>
							< Col sm={10} className="text-col">
								<img className="image-preview" src={documentSource} alt={item.lineText}/>
							</Col>

							{/*remove button column	*/}
							<Col sm={2} className="text-col">
								{editingAndAllowsImageUpload ?
									/* only show if relevant*/
									<button
										className="btn btn-default"
										type="button"
										onClick={this.handleRemoveButtonOnClick}
									>
										<FontAwesomeIcon icon="times-circle" /></button>
									: []}
							</Col>
						</Row>
						:
						/* no existing document content */
						<Row key={`itemdiv~${item.lineNumber}`}>
							<Col sm={12}>
								<input type="file"
									className="custom-file-input"
									id="file"
									accept=".gif, .jpg, .png"
									capture="camera" /* use camera if there's one */
									onChange={this.handleImageFileAdded}
									onClick={(event) => {
										event.target.value = null
									}} /* clear existing value each time clicked to allow multiple upload of same file e.g. if failure */
								/>
								<label className="btn btn-default" htmlFor="file">Add photo</label> 
							</Col>
							</Row>
				:
				/*photo column, full width if we have an image*/
				<Row key={`itemdiv~${item.lineNumber}`}>
					< Col sm={10} className="text-col">
							<EPSignaturePad
								handleImageClear={this.handleSignatureImageFileRemoved}
								handleImageSet={this.handleSignatureImageFileAdded}
								disabled={!editing}
								signature={documentSource}
							/>
					</Col>
				</Row>

		) //end return

	}//end render
}//end component


export default connect()(DataFormImage);